import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/forgotten',
    name: 'RequestPasswordReset',
    component: () =>
      import(
        /* webpackChunkName: "requestpasswordreset" */ '../views/RequestPasswordReset.vue'
      )
  },
  {
    path: '/reset/:token',
    name: 'PasswordReset',
    component: () =>
      import(
        /* webpackChunkName: "requestpasswordentry" */ '../views/PasswordResetEntry.vue'
      )
  },
  /* Audit route */
  {
    path: '/plans',
    name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
    children: [
      {
        path: 'select',
        name: 'SelectPlan',
        component: () =>
          import(
            /* webpackChunkName: "selectplan" */ '../components/Sections/SelectPlan.vue'
          )
      },
      {
        path: 'details',
        name: 'ConfirmPlan',
        component: () =>
          import(
            /* webpackChunkName: "plandetail" */ '../components/Sections/ConfirmPlan.vue'
          )
      },
      {
        path: 'section/:id',
        name: 'Section',
        component: () =>
          import(
            /* webpackChunkName: "selectplan" */ '../components/Sections/SectionTemplate.vue'
          ),
        props: true
      },
      {
        path: 'audit/summary',
        name: 'Audit Summary',
        component: () =>
          import(
            /* webpackChunkName: "selectplan" */ '../components/Sections/Summary.vue'
          ),
        props: true
      },
      {
        path: 'audit/additional-components',
        name: 'Additional Components',
        component: () =>
          import(
            /* webpackChunkName: "audit_qa" */ '../components/Sections/AdditionalInfo.vue'
          )
      },
      {
        path: 'audit/next-steps',
        name: 'Next steps',
        component: () =>
          import(
            /* webpackChunkName: "audit_addinfo" */ '../components/Sections/NextSteps.vue'
          )
      }
    ],
    meta: {
      requiresAuth: true,
      role: ['audit', 'manage', 'admin', 'super'],
      title: 'Authentication Callback'
    }
  },
  /* Admin route */
  {
    path: '/admin',
    name: 'Admin',
    meta: {
      requiresAuth: true,
      role: ['manage', 'admin', 'super'],
      title: 'Admin Portal'
    },
    component: () =>
      import(/* webpackChunkName: "admindash" */ '../views/Administrator.vue'),
    children: [
      {
        path: 'users',
        name: 'UserManagement',
        component: () =>
          import(
            /* webpackChunkName: "adminusers" */ '../components/Administrator/UserManager.vue'
          )
      },
      {
        path: 'upload',
        name: 'UploadQHA',
        component: () =>
          import(
            /* webpackChunkName: "adminupload" */ '../components/Administrator/UploadQHA.vue'
          )
      },
      {
        path: 'assign',
        name: 'AssignAudit',
        component: () =>
          import(
            /* webpackChunkName: "adminassign" */ '../components/Administrator/AuditAssign.vue'
          )
      },
      {
        path: 'list',
        name: 'ViewData',
        component: () =>
          import(
            /* webpackChunkName: "adminassign" */ '../components/Administrator/ViewAllQHAs.vue'
          )
      },
      {
        path: 'live',
        name: 'ViewLive',
        component: () =>
          import(
            /* webpackChunkName: "adminassign" */ '../components/Administrator/LiveQHAs.vue'
          )
      },
      {
        path: 'moderation',
        name: 'ModeratedPlans',
        component: () =>
          import(
            /* webpackChunkName: "adminassign" */ '../components/Administrator/ModeratedPlans.vue'
          )
      }
    ]
  },
  /* Reports route */
  {
    path: '/reports',
    name: 'Reports',
    component: () =>
      import(/* webpackChunkName: "graphdashview" */ '../views/Reporting.vue'),
    meta: {
      requiresAuth: true,
      role: ['audit', 'manage', 'report', 'admin', 'super'],
      title: 'Reports Dashboard'
    },
    children: [
      {
        path: 'dashboard',
        name: 'Reports Dashboard',
        component: () =>
          import(
            /* webpackChunkName: "graphdash" */ '../components/Reports/Reports.vue'
          )
      },
      // {
      //   path: 'benchmarking',
      //   name: 'Benchmarking',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "graphdash" */ '../components/Reports/Benchmarking.vue'
      //     )
      // },
      {
        path: 'custom',
        name: 'Custom Graphs',
        component: () =>
          import(
            /* webpackChunkName: "customgraph" */ '../components/Reports/Custom.vue'
          )
      },
      {
        path: 'query-data',
        name: 'Query Data',
        component: () =>
          import(
            /* webpackChunkName: "querydata" */ '../components/Reports/CustomAnalysis.vue'
          )
      },
      {
        path: 'export-audits',
        name: 'Export Audits',
        component: () => import('../components/Reports/ExportAudits.vue')
      }
    ]
  },
  {
    path: '/gradings',
    // name: 'Gradings',
    component: () =>
      import(/* webpackChunkName: "graphdashview" */ '../views/Reporting.vue'),
    meta: {
      requiresAuth: true,
      role: ['manage', 'admin', 'super'],
      title: 'Reports Dashboard'
    },
    children: [
      {
        path: '/',
        name: 'Gradings Dashboard',
        component: () =>
          import(
            /* webpackChunkName: "gradingreports" */ '../components/Reports/Sections.vue'
          )
      }
    ]
  },
  {
    path: '/sectiondata',
    // name: 'SectionComments',
    component: () =>
      import(/* webpackChunkName: "graphdashview" */ '../views/Reporting.vue'),
    meta: {
      requiresAuth: true,
      role: ['manage', 'admin', 'super'],
      title: 'Reports Dashboard'
    },
    children: [
      {
        path: '/',
        name: 'Theme Comments',
        component: () =>
          import(
            /* webpackChunkName: "sectioncomments" */ '../components/Reports/SectionComments.vue'
          )
      }
    ]
  },
  /* Super admin route */
  {
    path: '/super',
    name: 'SuperAdmin',
    component: () =>
      import(/* webpackChunkName: "superdash" */ '../views/SuperAdmin.vue'),
    children: [
      {
        path: 'users',
        name: 'SuperUserManagement',
        component: () =>
          import(
            /* webpackChunkName: "adminusers" */ '../components/SuperAdmin/UserManager.vue'
          )
      },
      {
        path: 'orgs',
        name: 'OrganisationManagement',
        component: () =>
          import(
            /* webpackChunkName: "adminupload" */ '../components/SuperAdmin/OrganisationManager.vue'
          )
      }
    ],
    meta: {
      requiresAuth: true,
      role: ['super'],
      title: 'Super Admin Dashboard'
    }
  },
  /* Support route */
  {
    path: '/support',
    name: 'Support',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Support.vue'),
    meta: {
      requiresAuth: true,
      role: ['audit', 'report', 'manage', 'admin', 'super']
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (
    (to.name === 'ConfirmPlan' || to.name === 'Section') &&
    !store.getters['plan/currentPlanId']
  ) {
    console.log('No plan selected. Redirecting...')
    return next('/plans/select')
  }
  next()
})

export default router
